import { ApiResponse, BfiApi, IApiResponse } from './bfiApi';
import { DrawBudgetStatus, InspectionStatusType } from '../../../constants/src';

export interface IInspection {
    id: number;
    orderedDate: Date;
    refreshedDate?: Date | null | undefined;
    statusId: InspectionStatusType;
    error: string;
    percentComplete: number;
    reportUrl: string;
}

export interface IDrawState {
    id: number;
    number: number;
    inspections: [IInspection];
}

export interface IInspectionState {
    id: number;
    status: DrawBudgetStatus;
    draws: [IDrawState];
    inspections: [IInspection];
}

export interface INewInspection {
    drawBudgetId: number;
    drawId?: number | null;
    fileIds: number[];
}

export interface IInspectionsStateResponse extends Omit<IInspectionState, 'result'> {
    result: IInspection;
}

export interface IInspectionListResponse extends Omit<IApiResponse, 'result'> {
    result: [IInspection];
}

export interface IInspectionResponse extends Omit<IApiResponse, 'result'> {
    result: IInspection;
}

export class InspectionsApi extends BfiApi {
    getInspectionsState(drawBudgetId: number): Promise<ApiResponse<IInspectionsStateResponse>> {
        return super.get(`/inspections/state/${drawBudgetId}`);
    }

    refreshInspection(id: number): Promise<IApiResponse> {
        return super.get(`/inspections/${id}/refresh`);
    }

    resetError(id: number): Promise<ApiResponse<IInspectionsStateResponse>> {
        return super.get(`/inspections/${id}/reset`);
    }

    createInspection(model: INewInspection): Promise<IApiResponse> {
        return super.post(`/inspections/new`, model);
    }

    linkToDraw(id: number, drawId: number): Promise<ApiResponse<IInspectionsStateResponse>> {
        return super.get(`/inspections/${id}/linktodraw?drawId=${drawId}`);
    }
}
